import { render, staticRenderFns } from "./translation-content.vue?vue&type=template&id=42742b9e&scoped=true"
import script from "./translation-content.vue?vue&type=script&lang=ts&setup=true"
export * from "./translation-content.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./translation-content.vue?vue&type=style&index=0&id=42742b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42742b9e",
  null
  
)

export default component.exports